import uiRouter from '@uirouter/angularjs';
import merge from 'lodash/merge';
import isEmpty from 'lodash/isEmpty';
import { AppSettingsModule } from 'services/settings.provider';
import { StoreInformationServiceModule } from 'services/data/storeInformation.service';
import { DataServiceModule } from 'services/data/data.service';
import { ModelServiceModule } from 'services/data/model/model.service';

export const PaypalServiceModule = angular
    .module('app.services.payment.paypalService', [
        uiRouter,
        AppSettingsModule,
        StoreInformationServiceModule,
        DataServiceModule,
        ModelServiceModule
    ]).service('paypalService', (
        settings,
        dataService,
        modelService,
        storeInformationService,
        $window,
        $q,
        $state
    ) => {
        return {
            prefill,
            isPayPalReturn,
            handleMerchantReturn,
            isConnectedComplete,
            isConnectedNeedsUpgrade,
            isConnectedUnverified,
            connect,
            disconnect,
            hasConnectedPaypalPermissions,
            setPaypalConnected,
            getBoolean
        };

        function prefill(initPaypal) {
            const returnUrl = `${$window.location.origin}${$state.href('settings.payments')}`;
            return dataService.create(settings.api.paypalPrefill, { returnUrl }).then((response) => {
                if (initPaypal && $window.PAYPAL) {
                    if ($window.PAYPAL.apps.Signup.loadScripts) {
                        $window.PAYPAL.apps.Signup.loadScripts();
                    }
                    $window.PAYPAL.apps.Signup.MiniBrowser.init();
                }
                return response;
            });
        }

        function handleMerchantReturn(data, params) {
            return dataService.create(settings.api.paypalUpsert, {
                paypalMerchantId: params.merchantIdInPayPal
            }).then((response) => {
                data.paypal = merge({}, data.paypal, response);
                return data;
            });
        }

        function isPayPalReturn(params) {
            return !isEmpty(params) && !!params.merchantIdInPayPal;
        }

        function isConnectedComplete(storeInfo) {
            const paypalInfo = storeInfo?.paypal || {};

            return !isEmpty(paypalInfo)
                && angular.isDefined(paypalInfo.acpStatus)
                && !!paypalInfo.merchantPayerId
                && getBoolean(paypalInfo.primaryEmailConfirmed)
                && getBoolean(paypalInfo.paymentsReceivable)
                && getBoolean(paypalInfo.oauthThirdPartyConfirmed);
        }

        function isConnectedUnverified(storeInfo) {
            const paypalInfo = storeInfo?.paypal || {};

            return !isEmpty(paypalInfo)
                && !!paypalInfo.merchantPayerId
                && getBoolean(paypalInfo.oauthThirdPartyConfirmed)
                && (getBoolean(paypalInfo.primaryEmailConfirmed) === false
                || getBoolean(paypalInfo.paymentsReceivable) === false);
        }

        function isConnectedNeedsUpgrade(storeInfo) {
            const paypalInfo = storeInfo?.paypal || {};

            return !isEmpty(paypalInfo)
                && !!paypalInfo.merchantPayerId
                && angular.isUndefined(paypalInfo.acpStatus);
        }

        function getBoolean(value) {
            return typeof value === 'string' ? value === 'true' : value;
        }

        function setPaypalConnected() {
            return getFreshStoreInfoModel()
                .then((store) => {
                    store.paypal.permissionsGranted = true;
                    return store;
                })
                .then(storeInformationService.save);
        }

        function getFreshStoreInfoModel() {
            const force = true;
            return storeInformationService.getStore(force)
                .then(response => modelService.makeModel(response, 'storeInformationModel'));
        }

        function saveStoreInformation(updatedInfo) {
            return storeInformationService.save(updatedInfo)
                .then(response => response);
        }

        function connect() {
            return dataService.create(settings.api.paypalConnect, {});
        }

        function disconnect(data) {
            let info = angular.copy(data);
            let paypalPropertiesToRetain = {
                isEnabled: info.paypal.isEnabled
            };
            info.paypal = paypalPropertiesToRetain;
            return $q.all([saveStoreInformation(info), dataService.create(settings.api.paypalDisconnect, {})]);
        }

        function hasConnectedPaypalPermissions(data) {
            return !!(data.paypal && data.paypal.permissions &&
                data.paypal.permissions.indexOf('EXPRESS_CHECKOUT') !== -1 &&
                data.paypal.permissions.indexOf('REFUND') !== -1 &&
                data.paypal.permissions.indexOf('AUTH_CAPTURE') !== -1);
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/payment/paypal/paypal.service.js